// extracted by mini-css-extract-plugin
export default {"search":"Search_search__SNb2G","filter":"Search_filter__-JId1"};